// extracted by css-extract-rspack-plugin
export default {"switcherBox":"switcherBox-_yNFqs","hoverReveal":"hoverReveal-Rwl8i8"};